import script from "./upFile.vue?vue&type=script&setup=true&lang=js"
export * from "./upFile.vue?vue&type=script&setup=true&lang=js"

import "./upFile.vue?vue&type=style&index=0&id=4cf81581&lang=less"

const __exports__ = script;

export default __exports__